import styles from './blocks.module.css';

export default function ConfirmDestructiveDialog({
    open,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    variant = 'danger',
    onConfirm,
    onCancel,
}) {
    if (!open) return null;

    const confirmClass = variant === 'danger' ? styles.buttonDanger : styles.buttonPrimary;

    return (
        <div className={styles.dialogOverlay} role="dialog" aria-modal="true">
            <div className={styles.dialog}>
                <h3 className={styles.dialogTitle}>{title}</h3>
                <p className={styles.dialogBody}>{message}</p>
                <div className={styles.dialogActions}>
                    <button type="button" className={styles.buttonSecondary} onClick={onCancel}>
                        {cancelLabel}
                    </button>
                    <button type="button" className={confirmClass} onClick={onConfirm}>
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
